export default __webpack_public_path__ + "static/media/bannerArtistasCallejeros.2c4a7fd1.jpg";